import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default class DelayLink extends React.Component {
    static propTypes = {
        delay: PropTypes.number,
    };
    static defaultProps = {
        delay: 30
    };
    static contextTypes = Link.contextTypes;
    static internal_click_state;
    constructor(props) {
        super(props);
        this.timeout = null;
        this.internal_click_state = false;
    }
    handleClick = (e) => {
        if (!this.internal_click_state) {
            if (e.defaultPrevented)
                return;
            e.preventDefault();
            this.internal_click_state = false;
            this.timeout = setTimeout(() => {
                this.internal_click_state = true;
                e.target.click();
                e.preventDefault();
            }, this.props.delay);
        }

    };
    render() {
        const props = Object.assign({}, this.props);
        delete props.delay;
        return (
            <Link {...props} onClick={this.handleClick} />
        );
    }
}